import { Box, Icon, InputCheckBox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { NEGATIVE_TRANSFERS } from 'modules/attendance/lib/enums'
import useIsRecentCompany from 'modules/timeoff/components/TimeoffCompensation/hooks/useIsRecentCompany'
import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

interface NegativeBalanceProps {
  form: TimeoffCompensationForm
}

interface IKeys {
  [key: string]: string
}

const NegativeBalance = ({ form }: NegativeBalanceProps) => {
  const negativeTransfersEnabled = form.negativeTransfersEnabled()

  const negativeTransfersWarningI18n: IKeys = {
    [NEGATIVE_TRANSFERS.limited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.warning.limited'
    ),
    [NEGATIVE_TRANSFERS.unlimited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.warning.unlimited'
    ),
  }

  const negativeTransfersI18n: IKeys = {
    [NEGATIVE_TRANSFERS.limited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.fields.negative_transfers.limited'
    ),
    [NEGATIVE_TRANSFERS.unlimited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.fields.negative_transfers.unlimited'
    ),
  }

  const negativeTransfersOptions = form.negativeTransfersOptions().map((negative_transfer) => ({
    label: negativeTransfersI18n[negative_transfer] || '',
    value: negative_transfer,
  }))
  const isRecentCompany = useIsRecentCompany()

  return (
    <Box gap="s8">
      <Box flexDirection="column" gap="s4">
        <Box flexDirection="row" alignItems="center" gap="s4">
          <InputCheckBox
            checked={negativeTransfersEnabled}
            onClick={() => form.onNegativeTransfersChange()}
          />
          <Text.Normal size="300" weight="medium">
            {i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.title'
            )}
          </Text.Normal>
        </Box>
        <Text size="200">
          {i18n.t(
            'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.description'
          )}
        </Text>
        {isRecentCompany && (
          <Text.Normal size="200">
            {negativeTransfersWarningI18n[form.get('negative_transfers').value]}
          </Text.Normal>
        )}
      </Box>
      {negativeTransfersEnabled && !isRecentCompany && (
        <>
          <Select
            value={form.get('negative_transfers').value}
            label={i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.labels.negative_transfers_options'
            )}
            options={negativeTransfersOptions}
            onChange={(selected) => form.setValues({ negative_transfers: selected })}
            showOriginalLabelText
          />
          <Box gap="s4" flexDirection="row" justifyContent="spaceBetween">
            <Icon.Medium icon="info-circle" color="grey800" />
            <Text.Normal size="200">
              {negativeTransfersWarningI18n[form.get('negative_transfers').value]}
            </Text.Normal>
          </Box>
        </>
      )}
    </Box>
  )
}

export default observer(NegativeBalance)
